import api from "@/api";

export default {
  state: {
    servicePayments: [],
  },
  getters: {
    servicePayments: (state) => state.servicePayments,
  },
  mutations: {
    setServicePayments(state, payments) {
      state.servicePayments = payments;
    },
  },
  actions: {
    fetchPolicyServicePayments: async ({ commit }, policyServiceId) => {
      try {
        const res = await api({ requiresAuth: true }).get(
          `/v1/policy-services/${policyServiceId}/service-payments`
        );
        commit("setServicePayments", res.data);
        return res.data;
      } catch (err) {
        console.error("Error fetching payments:", err);
        throw err;
      }
    },

    changePolicyServicePaymentPrice: async (
      _,
      { policyServiceId, total, state }
    ) => {
      if (state === "create") {
        return await api({ requiresAuth: true }).post(
          `/v1/policy-services/${policyServiceId}/policy-service-payments`,
          {
             total
          }
        );
      } else if (state === "update") {
        return await api({
          requiresAuth: true,
        }).patch(`/v1/policy-service-payments/${policyServiceId}`, { total });
      }
    },

    changePolicyServicePaidState: async (_, { policyServiceId, paid }) =>
      await api({ requiresAuth: true }).patch(
        `/v1/policy-service-payments/${[policyServiceId]}/paid`,
        {
          paid,
        }
      ),

    changePolicyServicePendingDate: async (_, { policyServicePaymentId, pendingDate }) =>
      await api({ requiresAuth: true }).patch(
        `/v1/policy-service-payments/${[policyServicePaymentId]}/pending-date`,
        {
          pending_date: pendingDate,
        }
      ),

    deletePolicyServicePayment: async (_, policyServiceId) => {
      try {
        await api({ requiresAuth: true, handleRouting: false }).delete(`/v1/policy-service-payments/${policyServiceId}`);
        return { success: true };
      } catch (err) {
        return {
          success: false,
          message: "Couldn't delete payment",
        };

      }
    },
  },
};
